import React, { useMemo } from 'react';
import { Alert, Divider } from 'antd';

import ReactMarkdown from 'react-markdown';

import DraggableAnswer from '../DraggableAnswer';
import DroppableAnswer from '../DroppableAnswer';

import CustomDragLayer from '../CustomDragLayer';

import defaultStyles from './style.less';

function shuffle(array) {
  const newArray = array.slice();
  let currentIndex = newArray.length;
  let temporaryValue;
  let randomIndex;
  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = newArray[currentIndex];
    newArray[currentIndex] = newArray[randomIndex];
    newArray[randomIndex] = temporaryValue;
  }
  return newArray;
}

function computeShuffle(question) {
  const valueRegex = /\[([^\]]*)\]\(\?[^\)]*\)/gi;

  let extraction = [];
  let match = null;
  while (match = valueRegex.exec(question.task)) extraction.push(match[1]);

  let options = [];
  extraction.forEach(m => options.push(...m.split('|').filter(a => !!a).map(s => s.replace(/\*/g, ''))));
  options = [...new Set(options)]; //remove duplicates

  return shuffle(options);
}

function QuestionDragAndDrop({  question,
                                answer,
                                disabled,
                                mutating,
                                onSetAnswer,
                                showValidationMessage,
                                styles = {
                                  step: defaultStyles.step,
                                  draglist: defaultStyles.draglist
                                }
                             }) {
  const draggable = useMemo(() => computeShuffle(question), [question]);

  const onDrag = (e) => {
    onSetAnswer(e);
  };

  const { task, comment } = question;

  return (
    <div className={styles.step}>
      { !disabled && (<CustomDragLayer />) }
      <div className={styles.draglist}>
        {!(disabled || mutating) && draggable.map((item) => {
          return <DraggableAnswer key={item} value={item} />;
        })}
      </div>
      <div className="desc">
        <ReactMarkdown
          key={question.slug}
          source={task}
          renderers={{ link: props => (
            <DroppableAnswer
              {...props}
              onChange={onDrag}
              answer={answer}
              question={question}
              disabled={disabled}
            />
          ) }}
        />
      </div>
      { showValidationMessage ? <Alert type="error" message="You must fill all placeholders" /> : null }
      { disabled && (
				<div className="desc">
          <>
            <Divider />
            <ReactMarkdown source={comment} />
          </>
				</div>
        )
      }
    </div>
  );
}

export default QuestionDragAndDrop;